import { type LBNodeData } from '@/proto/logiblocks/logiblocks';
import { AlertType, ALERT_TYPE_LABELS } from '@/common/alertType';
import { TRIGGER_ICON_COLOR } from '../../styles';
import {
  type GraphData,
  type LBNodeInfo,
  NodeCategory,
  OutputType,
} from '../../types';
import { defaultNodeData } from '../../graphUtils';
import { WarningIcon } from '@/assets/icons/icons';
import { AlertTriggerCustomizationUpdate } from './AlertTriggerCustomizationUpdate';

export const AlertTriggerNodeInfo: LBNodeInfo = {
  protobufNodeDataKey: 'alert_trigger',

  category: NodeCategory.TRIGGER,

  label: 'Alert Trigger',

  hasInput: false,

  getIcon: (size: number) => (
    <WarningIcon fill={TRIGGER_ICON_COLOR} width={size} height={size} />
  ),

  outputType: OutputType.SINGLE,

  getSubtitle: (data: LBNodeData, _graph: GraphData) => {
    const alertTypes = data.alert_trigger?.alert_types || [];
    const courierIds = data.alert_trigger?.courier_ids || [];
    const teamIds = data.alert_trigger?.team_ids || [];
    const originIds = data.alert_trigger?.origin_ids || [];
    const destinationIds = data.alert_trigger?.destination_ids || [];
    const productIds = data.alert_trigger?.product_ids || [];

    // Show alert type names if filtered
    if (alertTypes.length > 0) {
      const labels = alertTypes
        .slice(0, 2)
        .map((type) => ALERT_TYPE_LABELS[type as AlertType] || type);
      if (alertTypes.length > 2) {
        return `${labels.join(', ')} +${alertTypes.length - 2} more`;
      }
      return labels.join(', ');
    }

    const hasOtherFilters =
      courierIds.length > 0 ||
      teamIds.length > 0 ||
      originIds.length > 0 ||
      destinationIds.length > 0 ||
      productIds.length > 0;

    return hasOtherFilters ? 'All types (filtered)' : 'All Alerts';
  },

  CustomizationComponent: AlertTriggerCustomizationUpdate,

  createDefaultNodeData: () =>
    defaultNodeData('alert_trigger', {
      select_all: false,
      alert_types: [],
      courier_ids: [],
      team_ids: [],
      origin_ids: [],
      destination_ids: [],
      product_ids: [],
      select_all_teams: false,
      select_all_origins: false,
      select_all_products: false,
      select_all_transport_providers: false,
      select_all_destinations: false,
      select_all_alert_types: false,
    }),
};
